import { createContext, useContext } from 'react';

export type SearchHistoryContextValue = {
    item: string;
    onSelect: (query: string) => void;
};

export const SearchHistoryContext = createContext<SearchHistoryContextValue>({
    item: '',
    // eslint-disable-next-line 
    onSelect: () => {},
});

SearchHistoryContext.displayName = 'SearchHistoryContext';

export const SearchHistoryContextProvider = SearchHistoryContext.Provider;

export const useSearchHistoryContext = () => useContext(SearchHistoryContext);
